import { APIReferenceAttributes } from '@ardoq/api-types';
import { ReferenceLabelSource } from '@ardoq/data-model';

/**
 * ReferenceLabelSource members are default formatting options for reference labels.
 */
export const isFormattedByReferenceLabelSource = (
  filterSettingsValue: string | null
): filterSettingsValue is ReferenceLabelSource =>
  filterSettingsValue === ReferenceLabelSource.DISPLAY_TEXT ||
  filterSettingsValue === ReferenceLabelSource.DISPLAY_TEXT_OR_REFERENCE_TYPE ||
  filterSettingsValue === ReferenceLabelSource.REFERENCE_TYPE ||
  filterSettingsValue === ReferenceLabelSource.NONE;

/**
 * If filterSettingsValue is not a ReferenceLabelSource member, it is a field name.
 */
export const isFormattedByField = (filterSettingsValue: string) =>
  !isFormattedByReferenceLabelSource(filterSettingsValue);

export const isFormattedByReferenceType = (
  filterSettingsValue: string,
  referenceAttributes: APIReferenceAttributes
) => {
  if (filterSettingsValue === ReferenceLabelSource.REFERENCE_TYPE) {
    return true;
  }
  if (
    filterSettingsValue === ReferenceLabelSource.DISPLAY_TEXT_OR_REFERENCE_TYPE
  ) {
    return !referenceAttributes.displayText;
  }
  return false;
};
